import { render, staticRenderFns } from "./tutorials.pug?vue&type=template&id=c0408024&lang=pug&"
import script from "./tutorials.js?vue&type=script&lang=js&"
export * from "./tutorials.js?vue&type=script&lang=js&"
import style0 from "./tutorials.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0408024')) {
      api.createRecord('c0408024', component.options)
    } else {
      api.reload('c0408024', component.options)
    }
    module.hot.accept("./tutorials.pug?vue&type=template&id=c0408024&lang=pug&", function () {
      api.rerender('c0408024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tutorials/index.vue"
export default component.exports